export default __webpack_public_path__ + "resources/icons/d210-79b0.png";